/**
 * React Query hook for fetching registries
 */

import { useQuery } from "@tanstack/react-query";
import { useInvoicesClient } from "./useInvoicesClient";

export function useRegistries() {
  const client = useInvoicesClient();

  return useQuery({
    queryKey: ["registries"],
    queryFn: async () => {
      console.log("[useRegistries] Fetching registries...");
      const result = await client.listRegisters();
      console.log("[useRegistries] Fetched", result.registries.length, "registries:", result.registries);
      return result.registries;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes - registries change rarely
  });
}
